import React from 'react';

const FilterTabs = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8 sm:mb-12">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 text-sm sm:text-base ${
            activeCategory === category
              ? 'bg-primary text-on-primary shadow-lg transform scale-105'
              : 'bg-white text-stone-600 hover:bg-stone-100 border border-stone-200'
          }`}
          style={{
            backgroundColor: activeCategory === category ? '#C8A96A' : '#FFFFFF',
            color: activeCategory === category ? '#FFFFFF' : '#7A7A7A',
            borderColor: activeCategory === category ? '#C8A96A' : '#E0D6C8'
          }}
          onMouseEnter={(e) => {
            if (activeCategory !== category) {
              e.target.style.backgroundColor = '#F5EFE6';
            }
          }}
          onMouseLeave={(e) => {
            if (activeCategory !== category) {
              e.target.style.backgroundColor = '#FFFFFF';
            }
          }}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default FilterTabs;
